import classNames from "classnames";
import { useFieldWithInitialValue } from "Components/Hooks";
import { FieldMetaProps } from "formik";
import React from "react";
import {
  doesMetaHaveError,
  FieldNameOrOptions,
  getFieldOptions,
  renderErrorMessage,
} from "./Tools";

export function Dropdown(
  props: {
    options:
      | JSX.Element
      | string[]
      | Map<any, string> // Maps value to display element
      | { [K: string]: string };
    value?: string;
    placeholder?: string;
    showPlaceHolderAfterItemSelected?: boolean;
    handleMeta?: (meta: FieldMetaProps<any>) => React.ReactNode;
  } & FieldNameOrOptions,
) {
  const handleMeta = props.handleMeta || renderErrorMessage;
  const [field, meta] = useFieldWithInitialValue(
    getFieldOptions(props),
    props.value,
  );
  return (
    <div className="field">
      <div className="control is-expanded">
        <div
          className={classNames("select", {
            "has-value-selected": !!field.value,
          })}
          style={{ width: "100%" }}
        >
          <select
            {...field}
            className={classNames({
              "input-validation-error": doesMetaHaveError(meta),
            })}
            value={field.value || ""}
            style={{ width: "100%" }}
          >
            {props.placeholder !== undefined && (
              <option
                value=""
                hidden={!props.showPlaceHolderAfterItemSelected}
                disabled
              >
                {props.placeholder}
              </option>
            )}
            {"props" in props.options
              ? props.options
              : props.options instanceof Array
              ? props.options.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))
              : props.options instanceof Map
              ? [...props.options].map(([key, value]) => (
                  <option key={key.toString()} value={key.toString()}>
                    {value}
                  </option>
                ))
              : Object.entries(props.options).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))}
          </select>
        </div>
      </div>
      {handleMeta(meta)}
    </div>
  );
}
